import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalTables } from '../../../models'
import { spMetricHeaders } from './sp-metric-headers'

export const spProductMetricHeaders: Array<TGlobalTables> =
  spMetricHeaders.filter(
    (header) =>
      !(
        header === EReportColumnHeader.ShareOfVoice ||
        header === EReportColumnHeader.WinRate ||
        header === EReportColumnHeader.AvgRank
      )
  )
